<template>
  <div>关于我们</div>
</template>

<script>
export default {
  created() {
    this.$router.push({
      path: '/home/关于我们',
      params: {
        id: "关于我们"
      }
    })
  }
}
</script>

<style>

</style>